// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/35cd5ebc/" + chunkId + "." + __webpack_require__.h() + ".v35cd5ebc.js";
};